export class JobsToBeDoneModel {
    id: number;
    brandId: number;
    name: string;
    description: string;
    brands: string;
    canDelete: string;
    active: boolean;
    canEditName: boolean;
    canEditDescription: boolean;
    canEdit: string;
    canShow: number;

    constructor(){}
}



// WEBPACK FOOTER //
// ./src/app/client-core/dtos/jobs-to-be-done.model.ts